/**
 * Open target=_blank links without leaking window.opener.
 */
export function openBlankLink(targetUrl: string): void {
  const newWindow = window.open();
  if (!newWindow) return;
  newWindow.opener = null;
  newWindow.location.href = targetUrl;
}

export function initBlankLinks(root: Document | Element = document): void {
  const blankLinks = Array.from(root.querySelectorAll('a[target="_blank"]'));
  if (!blankLinks.length) return;

  blankLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const current = e.currentTarget as HTMLAnchorElement;
      openBlankLink(current.href);
    });
  });
}
